// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-modal-packrat-bundle{overflow:hidden}.ac-modal-packrat-bundle__content{width:500px}.ac-modal-packrat-bundle__label{padding-left:2rem;font-weight:700;padding-top:1rem}.ac-modal-packrat-bundle__main-info{padding-left:2rem}.ac-modal-packrat-bundle__actions{display:flex;padding:1rem 2rem;flex-direction:column}.ac-modal-packrat-bundle__btn{margin-bottom:1rem}.ac-modal-packrat-bundle__files-wrapper{overflow:auto}\n", ""]);
// Exports
module.exports = exports;
